import { PropagateLoader } from "react-spinners";
// import logo from "../assets/navbar/logolg.webp";

const INLoader = () => {
  return (
    <div className="customLoaderContainer" role="status" aria-live="polite" aria-label="Loading">
      <PropagateLoader className="loader" size={16} color="#02033F" loading />
      <span style={{ position: "absolute", width: "1px", height: "1px", padding: 0, margin: "-1px", overflow: "hidden", clip: "rect(0,0,0,0)", whiteSpace: "nowrap", border: 0 }}>
        Loading...
      </span>
    </div>
  );
};

export default INLoader;
